var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_723_2233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.82391V24H24V7.82391H0ZM6 22.9439H1.44V18.8161H6.04688V22.9439H6ZM6 18.0469H1.44V13.9219H6.04688V18.0469H6ZM6 13.103H1.44V8.9761H6.04688V13.1039L6 13.103ZM11.52 22.9439H6.91219V18.8161H11.52V22.9439ZM11.52 18.0478H6.91219V13.9219H11.52V18.0478ZM11.52 13.1039H6.91219V8.9761H11.52V13.1039ZM17.04 22.9439H12.4322V18.8161H17.04V22.9439ZM17.04 18.0478H12.4322V13.9219H17.04V18.0478ZM17.04 13.1039H12.4322V8.9761H17.04V13.1039ZM22.56 22.9439H17.9531V18.8161H22.5609L22.56 22.9439ZM22.56 18.0478H17.9531V13.9219H22.5609L22.56 18.0478ZM22.56 13.1039H17.9531V8.9761H22.5609L22.56 13.1039Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8639 3.2639V4.12781V4.55999H18.4322H16.9922H16.56V4.12781V3.2639H7.05609V4.12781V4.55999H6.62391H5.13609H4.70391V4.12781V3.2639H0V7.29609H24V3.2639H18.8639Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62384 0H5.18384V4.03219H6.62384V0Z",
    fill: "current",
    stroke: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4322 0H16.9922V4.03219H18.4322V0Z",
    fill: "current",
    stroke: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_723_2233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.00097eebfc762dfa9c34b2db2a75aa96.svg";
export { ForwardRef as ReactComponent };